<template>
  <div class="author-detail-page">
    <!-- Author Profile -->
    <div class="author-profile">
      <div class="profile-inner">
        <div class="author-avatar">
          <img v-if="author.avatar" :src="author.avatar" :alt="author.name" />
          <div v-else class="avatar-placeholder">
            <i class="el-icon-user"></i>
          </div>
        </div>
        <div class="author-info">
          <h1 class="page-title">{{ $t("authorDetail.title") }}</h1>
          <h2 class="author-name">{{ author.name }}</h2>
          <p class="author-bio">{{ author.bio }}</p>
        </div>
      </div>
    </div>

    <!-- Published Books -->
    <div class="books-section">
      <div class="books-inner">
        <h2 class="section-title">{{ $t("authorDetail.publishedBooks") }}</h2>
        <el-row :gutter="24">
          <el-col
            :span="4"
            v-for="(book, index) in author.books"
            :key="index"
          >
            <book-card :book="book" @click="goToBookDetail(book)" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import BookCard from "@/components/BookCard.vue";

export default {
  name: "AuthorDetailPage",
  components: { BookCard },
  data() {
    return {
      author: {
        id: 1,
        name: "李金強",
        avatar: null,
        bio: "香港大學歷史學系教授（榮休）。曾先後在國際知識論壇和學術界推進知識管理，當前以日新月異的學術和研發方式呈現他的學術貢獻。研究生涯長達多年，見證了幾次時代學術典範。\n\n對香港和臺灣大學的比較研究具有獨到見解。十年國際間的研究，其國際論壇的報告會反映了「全球化」、「區域化」——兩個方面在區域研究中的關鍵特徵。\n\n針對因境遷造——世行大學",
        books: [],
      },
    };
  },
  created() {
    // Mock books
    for (let i = 0; i < 5; i++) {
      this.author.books.push({
        id: i + 1,
        title: "教育的性別視角——理論與教學實踐研究",
        titleEn: "This is an example of an English title.",
        author: this.author.name,
        date: "2024年8月",
        cover: null,
      });
    }
  },
  methods: {
    goToBookDetail(book) {
      this.$router.push({ path: `/book/${book.id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.author-detail-page {
  flex: 1;
}

/* ===== Profile ===== */
.author-profile {
  padding: 40px 0;
}

.profile-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  gap: 32px;
}

.author-avatar {
  flex-shrink: 0;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 48px;
      color: #ccc;
    }
  }
}

.author-info {
  flex: 1;
  min-width: 0;

  .page-title {
    font-size: 16px;
    color: $primary-orange;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .author-name {
    font-size: 22px;
    color: $text-dark;
    font-weight: 700;
    margin-bottom: 16px;
  }

  .author-bio {
    font-size: 14px;
    line-height: 1.8;
    color: $text-gray;
    white-space: pre-line;
  }
}

/* ===== Books Section ===== */
.books-section {
  padding: 32px 0 48px;
  border-top: 1px solid $border-color;
}

.books-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: $text-dark;
  margin-bottom: 20px;
}
</style>
